/**
 * Copyright 2025 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

/**
 * Loads the Pendo analytics script.
 */
function loadPendoScript() {
  window.pendo = {
    initialize: () => { },
    identify: () => { },
    updateOptions: () => { },
    pageLoad: () => { },
    track: () => { },
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://cdn.pendo.io/agent/static/d6b78569-264b-416e-4676-2587f8c44d7f/pendo.js';
  document.body.appendChild(script);

  return new Promise((resolve, reject) => {
    script.onload = () => {
      if (window.pendo) {
        resolve(window.pendo);
      } else {
        reject(new Error('Pendo object not available after script load'));
      }
    };

    script.onerror = () => {
      reject(new Error('Failed to load Pendo script'));
    };
  });
}

export default loadPendoScript;
